/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Participant
 */
export interface Participant {
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    fullName: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    role: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    mobile: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    fax: string | null;
    /**
     * 
     * @type {string}
     * @memberof Participant
     */
    correspondenceAddress: string | null;
}

/**
 * Check if a given object implements the Participant interface.
 */
export function instanceOfParticipant(value: object): value is Participant {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('fax' in value) || value['fax'] === undefined) return false;
    if (!('correspondenceAddress' in value) || value['correspondenceAddress'] === undefined) return false;
    return true;
}

export function ParticipantFromJSON(json: any): Participant {
    return ParticipantFromJSONTyped(json, false);
}

export function ParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Participant {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'role': json['role'],
        'email': json['email'],
        'phone': json['phone'],
        'mobile': json['mobile'],
        'fax': json['fax'],
        'correspondenceAddress': json['correspondenceAddress'],
    };
}

export function ParticipantToJSON(value?: Participant | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'role': value['role'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'fax': value['fax'],
        'correspondenceAddress': value['correspondenceAddress'],
    };
}

